// Module
var code = "<section>\n\n    {% if page.description %}\n    <div>\n        {{ page.description | markdownify }}\n    </div>\n    {% endif %}\n\n</section>\n";
// Exports
module.exports = code;